<template>
  <div />
</template>

<script>
export default {
  name: 'RefinitivWorldCheckDialog'
}
</script>
